<input
  #fileInput
  id="fileInput"
  class="d-none"
  type="file"
  accept="image/*"
  (change)="handleFileInput($event.target)"
/>
<div class="card dialog-box">
  <div class="card-header">
    Report Header Logo
    <span class="float-end" (click)="onDismiss()"
      ><i class="fa-solid fa-xmark"></i
    ></span>
  </div>
  <div>
    @if (logoUsed === "site" && siteData?.id) {
      <div class="mb-4">This logo is used on reports for this site.</div>
      <div class="d-flex flex-wrap gap-3 justify-content-center">
        <div
          role="button"
          class="border p-4 flex-fill w-100 rounded border-2 bg-white text-dark fw-semibold border-secondary border-2 text-center"
          (click)="openFileEditor('site')"
        >
          Change Logo
        </div>

        <div
          role="button"
          class="border p-4 flex-fill w-100 rounded bg-danger text-white fw-semibold text-center"
          (click)="removeLogo('site')"
        >
          Delete Logo
        </div>
      </div>
    }

    @if (
      logoUsed === "company" && clientData?.id && clientData?.is_subcontracting
    ) {
      <div class="mb-4">
        This logo is used on reports for all sites under this client.
      </div>

      <div class="d-flex flex-wrap gap-3 justify-content-center">
        @if (siteData?.id) {
          <div
            role="button"
            class="text-center border p-4 flex-fill w-100 rounded border-2 bg-white text-primary fw-semibold border-secondary border-2"
            (click)="openFileEditor('site')"
          >
            Upload logo for just this site
          </div>
        }
        <div
          role="button"
          class="border p-4 flex-fill w-100 rounded border-2 bg-white text-dark fw-semibold border-secondary border-2 text-center"
          (click)="openFileEditor('client')"
        >
          Change Logo
        </div>

        <div
          role="button"
          class="border p-4 flex-fill w-100 rounded bg-danger text-white fw-semibold text-center"
          (click)="removeLogo('client')"
        >
          Delete Logo
        </div>
      </div>
    }

    @if (logoUsed === "subscriber") {
      <div class="d-flex gap-3 flex-wrap justify-content-center">
        @if (siteData?.id) {
          <div
            role="button"
            class="text-center border p-4 flex-fill w-100 rounded border-2 bg-white text-primary fw-semibold border-secondary border-2"
            (click)="openFileEditor('site')"
          >
            Upload logo for just this site
          </div>
        }

        @if (clientData?.id && clientData?.is_subcontracting) {
          <div
            role="button"
            class="text-center border p-4 flex-fill w-100 rounded border-2 bg-white text-primary border-secondary border-2"
            (click)="openFileEditor('client')"
          >
            Upload logo for this Client
          </div>
        }

        <div
          role="button"
          class="border p-4 flex-fill w-100 rounded bg-danger text-white fw-semibold text-center"
          (click)="removeLogo('company')"
        >
          Delete Logo
        </div>
      </div>
    }

    @if (!logoUsed) {
      <div class="d-flex flex-wrap gap-3 justify-content-center">
        @if (!clientData?.is_subcontracting) {
          <div
            role="button"
            class="text-center border p-4 flex-fill w-100 rounded border-2 bg-white text-dark fw-semibold border-secondary border-2 text-center"
            (click)="openFileEditor('company')"
          >
            Upload Your Company Logo
          </div>
        }
        @if (siteData?.id) {
          <div
            role="button"
            class="text-center border p-4 flex-fill w-100 rounded border-2 bg-white text-primary fw-semibold border-secondary border-2"
            (click)="openFileEditor('site')"
          >
            Upload logo for just this site
          </div>
        }
        @if (clientData?.id && clientData?.is_subcontracting) {
          <div
            role="button"
            class="text-center border p-4 flex-fill w-100 rounded border-2 bg-white text-primary border-secondary border-2"
            (click)="openFileEditor('client')"
          >
            Upload logo for this Client
          </div>
        }
      </div>
    }
  </div>
</div>
